import JobZImage from "../../../../common/jobz-img";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { loadScript } from "../../../../../globals/constants";
import axiosInstance from "../../../../../axiosInstance";
import { API_URL } from "../../../../../config";

const getColorClass = (char) => {
    if (!char) return "bg-default";
    const letter = char.toUpperCase();
    const colors = {
        A: "bg-red", B: "bg-blue", C: "bg-green", D: "bg-orange", E: "bg-purple",
        F: "bg-teal", G: "bg-pink", H: "bg-indigo", I: "bg-yellow", J: "bg-cyan",
        K: "bg-lime", L: "bg-rose", M: "bg-amber", N: "bg-violet", O: "bg-emerald",
        P: "bg-fuchsia", Q: "bg-sky", R: "bg-gray", S: "bg-zinc", T: "bg-stone",
        U: "bg-neutral", V: "bg-blue-500", W: "bg-orange-600", X: "bg-indigo-500",
        Y: "bg-pink-600", Z: "bg-teal-600",
    };
    return colors[letter] || "bg-default";
};

function SectionCandidateAppliedJobs() {
    const { t } = useTranslation();
    const [appliedJobs, setAppliedJobs] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadScript("js/custom.js");

        const fetchAppliedJobs = async () => {
            try {
                setLoading(true);
                const response = await axiosInstance.get(`${API_URL}/getAllAppliedJob`);
                if (response.data.status === 200) {
                    setAppliedJobs(response.data.data || []);
                } else {
                    setError("Failed to fetch applied jobs.");
                }
            } catch (error) {
                console.error("Error fetching applied jobs:", error);
                setError("An error occurred while fetching jobs. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchAppliedJobs();
    }, []);

    return (
        <>
            <div className="panel panel-default">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0">{t("Applied Jobs")}</h4>
                </div>
                <div className="panel-body wt-panel-body bg-white">
                    <div className="dashboard-messages-box-scroll scrollbar-macosx">
                        <div className="dashboard-messages-box">
                                    {loading ? (
                                        <p>{t("Loading jobs")}...</p>
                                    ) : error ? (
                                        <p className="text-danger">{error}</p>
                                    ) : (
                                        <ul>
                                            {appliedJobs.length > 0 ? (
                                                appliedJobs.slice(0, 5).map((applied) => {
                                                    const job = applied.job || {};
                                                    return (
                                                        <li key={applied.id}>
                                                            <div className="twm-jobs-list-style1 mb-5">
                                                                <div className="twm-media">
                                                                    {job.companyLogo ? (
                                                                        <JobZImage src={job.companyLogo} alt={job.title} />
                                                                    ) : (
                                                                        <div className={`company-logo-placeholder ${getColorClass(job.company?.charAt(0))}`}>
                                                                            {job.company?.charAt(0)?.toUpperCase() || ''}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="twm-mid-content">
                                                                    <h4 className="twm-job-title">
                                                                        {job.title}{" "}
                                                                        {job.contract_time && (
                                                                            <span className="twm-job-post-duration">
                                                                                /{" "}
                                                                                {job.contract_time
                                                                                    .replace("_", " ")
                                                                                    .replace(/\b\w/g, (c) => c.toUpperCase())}
                                                                            </span>
                                                                        )}
                                                                    </h4>
                                                                    <p className="twm-job-address">{job.location}</p>
                                                                </div>
                                                                <div className="twm-right-content">
                                                                    <div className="twm-jobs-category">
                                                                        <span
                                                                            className={`${job.contract_type === "contract"
                                                                                ? "twm-bg-sky"
                                                                                : job.contract_type === "permanent"
                                                                                    ? "twm-bg-golden"
                                                                                    : ""
                                                                                }`}
                                                                        >
                                                                            {job.contract_type || " "}
                                                                        </span>
                                                                    </div>
                                                                    <div className="twm-jobs-amount">
                                                                        <span>
                                                                            {job.min_salary ? `$${job.min_salary}` : ""}
                                                                            {job.min_salary && job.max_salary ? " / " : ""}
                                                                            {job.max_salary ? job.max_salary : ""}
                                                                        </span><br />
                                                                        <span>{applied.status.toUpperCase() || "N/A"}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    );
                                                })
                                            ) : (
                                                <p>{t("No jobs found.")}</p>
                                            )}
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
        </>
    )
}

export default SectionCandidateAppliedJobs;